// RITA-1602 — Höhe der Handbuch-Spalte: Sie beginnt auf Höhe der Titelzeile und klebt beim Rollen unter dem App-Kopf.
// Solange die Seite noch nicht gerollt ist, steht sie also tiefer. Damit der Link unten und das Ende des Texts auch dann
// im Fenster bleiben, richtet sich die Höchsthöhe nach der tatsächlichen Oberkante. Gesetzt wird direkt am Element, damit
// das Rollen der Seite den langen Kapiteltext nicht jedes Mal neu aufbaut.
import { useLayoutEffect, useRef } from 'react';

const MINDESTHOEHE_PX = 240;

export default function useLeistenHoehe<T extends HTMLElement>(
  aktiv: boolean,
  obenAbstandPx: number,
  restPlatz: string,
) {
  const ref = useRef<T>(null);
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    if (!aktiv) {
      element.style.maxHeight = '';
      return undefined;
    }
    let bild = 0;
    const messen = () => {
      bild = 0;
      const oben = Math.max(element.getBoundingClientRect().top, obenAbstandPx);
      element.style.maxHeight = `max(${MINDESTHOEHE_PX}px, calc(100vh - ${Math.round(oben)}px - ${restPlatz}))`;
    };
    const anstossen = () => {
      if (!bild) bild = window.requestAnimationFrame(messen);
    };
    messen();
    window.addEventListener('scroll', anstossen, { passive: true, capture: true });
    window.addEventListener('resize', anstossen);
    return () => {
      window.removeEventListener('scroll', anstossen, { capture: true });
      window.removeEventListener('resize', anstossen);
      if (bild) window.cancelAnimationFrame(bild);
    };
  }, [aktiv, obenAbstandPx, restPlatz]);
  return ref;
}
